/**
 * Club-coloured washes.
 *
 * A card showing two clubs gets a diagonal tint of each club's colour
 * running in from its own corner and fading out before the middle. It is
 * the visual grammar every football broadcast uses, and it lets a viewer
 * tell two cards apart at a glance without reading a word.
 *
 * This only produces CSS custom properties. The gradients themselves live
 * in `theme.css` (`.app-team-wash`), so the alpha, angle and dark-mode
 * behaviour are defined once rather than per component.
 */

import { teamWashRgb } from "../data/teamBranding";

/**
 * Two-club wash, for anything showing a matchup.
 *
 * @param {string} awayTeamId  tints in from the left
 * @param {string} homeTeamId  tints in from the right
 * @returns {object} style object of CSS custom properties
 */
export function teamWashStyle(awayTeamId, homeTeamId) {
  const away = teamWashRgb(awayTeamId);
  const home = teamWashRgb(homeTeamId);

  const style = {};
  if (away) style["--wash-away-rgb"] = away;
  if (home) style["--wash-home-rgb"] = home;
  return style;
}

/**
 * Single-club wash, for a surface that belongs to one club.
 * Tints in from the left only.
 */
export function singleTeamWashStyle(teamId) {
  const rgb = teamWashRgb(teamId);
  return rgb ? { "--wash-away-rgb": rgb } : {};
}

/** Convenience for a game record. */
export function gameWashStyle(game) {
  if (!game) return {};
  return teamWashStyle(game.awayTeamId, game.homeTeamId);
}
